module.exports = __webpack_public_path__ + "kvartira_ili_apartamenty.a6c042700496e08543ef.jpg";